import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

//UI
import { Button, Modal, Table, Loader, Message } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import HeaderCatalog from "../../../components/headerCatalog";
import ActiveIcon from "../../../components/activeIcon";

//Actions
import { fetchAirlines } from "../../../redux/actions/catalogs/airline/fetchAirlines";
import { deleteAirline } from "../../../redux/actions/catalogs/airline/deleteAirline";

// Resources
import { scrollToTop } from "../../resources/utils";

export default function AirlineList() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const airlineState = useSelector((state) => state.airlineReducer);
  
  useEffect(() => {
    dispatch(fetchAirlines());
    scrollToTop();
  }, []);

  if (airlineState.fetching || airlineState.processing) {
    return <Loader active inline />;
  }
  
  if (airlineState.message === "resource deleted successfully") {
    dispatch(fetchAirlines());
  }

  const handleDeleteAirline = (airline_id) => {
    dispatch(deleteAirline(airline_id));
  };

  return (
    <>
      {airlineState.error ? (
        <Message negative content={t(airlineState.error)} />
      ) : (
        ""
      )}
      <HeaderCatalog title={t("airline_title")} message={airlineState.message} to="/airlines_new" />
      <Table color="blue" striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell></Table.HeaderCell>
            <Table.HeaderCell>{t("airline_name")}</Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {airlineState.airlines.map((airline) => (
          <Table.Row key={airline.id}>
            <Table.Cell collapsing><ActiveIcon active={airline.active} /></Table.Cell>
            <Table.Cell>{t(airline.name)}</Table.Cell>
            <Table.Cell collapsing>
              <Link to={`/airlines/${airline.id}`}><Button circular color='blue' icon='pencil alternate' /></Link>
              <Modal
                trigger={
                  <Button circular color='red' icon='trash alternate' />
                }
                content={t("airline_delete")}
                actions={[
                  t("canceled_button"),
                    {
                      key: "eliminar",
                      content: t("delete_button"),
                      className: "delete_button icon_color",
                      onClick: () => handleDeleteAirline(airline.id),
                    },
                ]}
                size="tiny"
              />
            </Table.Cell>
          </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  );
}
